import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastService } from 'angular-toastify';
import { ParkingZone } from '../../../../../../core/models/parking/parking-zone.model';
import { ApiParkingZoneService } from '../../../../../../core/services/api/parking/api-parking-zone.service';

@Component({
  selector: 'app-modal-parking-zone',
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-parking-zone.component.html'
})
export class ModalParkingZoneComponent implements OnInit {
  @Input() data: ParkingZone | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() saveSuccess = new EventEmitter<void>();

  public isSaving = false;
  public formData: Partial<ParkingZone> = {
    lot: 0,
    isOnline: false
  };

  // Mock Dropdown Options
  public floorOptions: string[] = ['ชั้น 1', 'ชั้น 2', 'ชั้น 3', 'ชั้น 4', 'ชั้น 1-4'];
  public parkingTypeOptions: string[] = ['อาคารจอดรถยนต์', 'อาคารจอดรถมอเตอร์ไซค์', 'ลานจอดรถยนต์', 'ลานจอดรถมอเตอร์ไซค์'];

  // Search texts for autocomplete inputs to prevent saving invalid options
  public searchFloorText: string = '';
  public searchParkingTypeText: string = '';

  get filteredFloorOptions(): string[] {
    const s = (this.searchFloorText || '').toLowerCase();
    return this.floorOptions.filter(f => f.toLowerCase().includes(s));
  }

  get filteredParkingTypeOptions(): string[] {
    const s = (this.searchParkingTypeText || '').toLowerCase();
    return this.parkingTypeOptions.filter(pt => pt.toLowerCase().includes(s));
  }

  // Dropdown states
  public openDropdown: string | null = null;

  constructor(
    private apiService: ApiParkingZoneService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.formData = { ...this.data };
      this.searchFloorText = this.formData.floor || '';
      this.searchParkingTypeText = this.formData.parkingType || '';
    }
  }

  public onClickInsideModal(event: Event): void {
    event.stopPropagation();
    this.closeDropdowns();
  }

  public closeDropdowns(): void {
    if (this.openDropdown === 'floor') {
      if (this.floorOptions.includes(this.searchFloorText)) {
        this.formData.floor = this.searchFloorText;
      } else {
        this.searchFloorText = this.formData.floor || '';
      }
    } else if (this.openDropdown === 'parkingType') {
      if (this.parkingTypeOptions.includes(this.searchParkingTypeText)) {
        this.formData.parkingType = this.searchParkingTypeText;
      } else {
        this.searchParkingTypeText = this.formData.parkingType || '';
      }
    }
    this.openDropdown = null;
  }

  // Dropdown UI logic
  public onInputFocus(menu: string): void {
    if (this.openDropdown && this.openDropdown !== menu) {
      this.closeDropdowns();
    }
    this.openDropdown = menu;
  }

  public toggleDropdown(menu: string, event: Event): void {
    event.stopPropagation();
    if (this.openDropdown === menu) {
      this.closeDropdowns();
    } else {
      if (this.openDropdown) this.closeDropdowns();
      this.openDropdown = menu;
    }
  }

  public selectFloor(val: string): void {
    this.formData.floor = val;
    this.searchFloorText = val;
    this.openDropdown = null;
  }

  public selectParkingType(val: string): void {
    this.formData.parkingType = val;
    this.searchParkingTypeText = val;
    this.openDropdown = null;
  }

  public toggleOnline(): void {
    this.formData.isOnline = !this.formData.isOnline;
  }

  public onDiscard(): void {
    this.close.emit();
  }

  public onSave(): void {
    this.closeDropdowns(); // Ensure inputs are validated first

    if (!this.formData.name || !this.formData.floor || !this.formData.parkingType) {
      this.toast.error('กรุณากรอกข้อมูลให้ครบถ้วนและเลือกจากตัวเลือกให้ถูกต้อง');
      return;
    }

    this.isSaving = true;

    // Simulate API call
    setTimeout(() => {
      this.toast.success('บันทึกข้อมูลโซนลานจอดสำเร็จ (Mock API)');
      this.isSaving = false;
      this.saveSuccess.emit();
      this.close.emit();
    }, 800);
  }
}
